// extracted by mini-css-extract-plugin
export default {"similarVenuesContainer":"_1qq_xroqT4DWWgjSf0A8xZ","similarVenueCards":"_3K3Z9VD1xmjhmxWZGkO5wN","venueContainer":"_1WZVPXeWqz322HmapscO-B"};